import React, { useState } from "react";
import PrivateComponent from "../../common/private-component/private-component.component";
import GettingStartedMenu from "../getting-started-menu/getting-started-menu.component";
import GettingStartedContent from "../getting-started-content/getting-started-content.component";
import {USER_MANUAL} from "../../constants/user-manual.constants"

import "./getting-started.component.scss";


const GettingStarted = () => {

    const [activeSummary, setActiveSummary] = useState(USER_MANUAL.HOME_PAGE);
    return (
        <PrivateComponent >
            <div>
                <main className="mx-auto px-4 sm:px-6 lg:px-8 m-20">
                    <div className="flex flex-row">
                        <div className="getting-started-menu flex-shrink-0 sm:m-1/4 md:w-1/3 lg:w-1/4">
                            <GettingStartedMenu activeSummary={activeSummary} setActiveSummary={setActiveSummary} />
                        </div>

                        <div className="getting-started-content">
                            <GettingStartedContent activeSummary={activeSummary} setActiveSummary={setActiveSummary} />
                        </div>
                    </div>
                </main>
            </div>

        </PrivateComponent>

    )
}

export default GettingStarted
